import isBrowser from './isBrowser';
import { getHostname } from './location';

const hostname = (): string => (isBrowser() ? getHostname() : 'fabfitfun.com');

export { hostname };
